import React from 'react';
import { Card, Typography, Space } from 'antd';
import { ShopOutlined, EnvironmentOutlined } from '@ant-design/icons';

interface TakeawayInfoProps {
    storeAddress: any; // Type should be imported from types/address
    className?: string;
    whatsappNumber?: string;
}

export const TakeawayInfo: React.FC<TakeawayInfoProps> = ({
    storeAddress,
    className,
    whatsappNumber: _
}) => {
    // Si hay dirección configurada
    if (storeAddress) {
        return (
          <Card
            className={`${className} border-default`}
            variant={'borderless'}
            style={{ backgroundColor: 'var(--bg-default)' }}
          >
            <Space orientation="vertical" size="small" style={{ width: '100%' }}>
              <div className="d-flex align-items-center">
                <EnvironmentOutlined
                  className="text-primary mr-2"
                  style={{ fontSize: '1.2rem' }}
                />
                <Typography.Text strong>Punto de Retiro</Typography.Text>
              </div>

              <div className="pl-4 ml-1">
                <Typography.Text className="d-block">
                  {storeAddress.street} {storeAddress.number}
                </Typography.Text>
                <Typography.Text type="secondary" className="d-block small">
                  {storeAddress.city}, {storeAddress.state}
                </Typography.Text>
                {/* 
                         TODO: Próxima iteración
                         <Typography.Text type="secondary" className="d-block small mt-2">
                            Horario estimado: Hoy 15:00 - 19:00
                         </Typography.Text> 
                        */}
              </div>
            </Space>
          </Card>
        );
    }

    // Si NO hay dirección configurada (Fallback)
    return (
        <Card className={`${className} border-default`} variant={'borderless'}
              style={{ backgroundColor: 'var(--bg-default)' }}>
            <Space orientation="vertical" size="middle" style={{ width: '100%' }}>
                <div className="d-flex align-items-center">
                    <ShopOutlined className="text-secondary me-2" style={{ fontSize: '1.2rem' }} />
                    <Typography.Text strong>Retiro a Coordinar</Typography.Text>
                </div>

                <Typography.Text type="secondary">
                    Al finalizar el pedido podrás coordinar la entrega por whatsapp
                </Typography.Text>

                {/*{whatsappNumber && (*/}
                {/*    <Button*/}
                {/*        type="default"*/}
                {/*        icon={<WhatsAppOutlined />}*/}
                {/*        href={`https://wa.me/${whatsappNumber}?text=Hola, quiero coordinar el retiro de mi pedido`}*/}
                {/*        target="_blank"*/}
                {/*        block*/}
                {/*        className="mt-2"*/}
                {/*    >*/}
                {/*        Contactar por WhatsApp*/}
                {/*    </Button>*/}
                {/*)}*/}
            </Space>
        </Card>
    );
};
